import chainIcons from '../../chainIconMapping.json';
import evmNetworks from '../../evmNetworks.json';
import { VerifiableCredential } from './credentials';

export * from './credentials';
// Step 1: Define an array with the type options
export const evidenceTypes = ['selfie', 'idDocumentFront', 'idDocumentBack'] as const;

// Step 2: Use the array to create the type
export type EvidenceType = (typeof evidenceTypes)[number] | string;

export type Evidence = {
  content: EvidenceType;
  'content-type': string;
  downloadUrl?: string;
  blob?: Uint8Array;
  sha256: string;
};

export type DownloadedEvidence = {
  content: EvidenceType;
  'content-type': string;
  sha256: string;
  evidenceData: Uint8Array;
};

export type Credentials = {
  credentials: VerifiableCredential[];
  evidences: Evidence[];
};

export type Icons = Record<
  string,
  {
    icon: string;
    explorer?: string;
  }
>;

export const icons: Icons = chainIcons as Icons;

export type NetworkConfig = {
  chainId: number;
  symbol?: string;
  network: string;
  isMainnet?: boolean;
  aliases?: string[];
};

type NetworkConfigs = Record<string, NetworkConfig>;
export const networkConfigs: NetworkConfigs = evmNetworks as NetworkConfigs;
